import { TrustStrip } from "@/components/molecules";
import {
  HomeHero,
  ShopByCondition,
  QuizCta,
  Bestsellers,
  MeetDrBurns,
  Differentiators,
  Testimonials,
  TrustVerification,
  SubscribeSave,
  PressCoverage,
} from "@/components/sections";
import { organizationJsonLd } from "@/lib/seo";
import { Seo } from "@/components/seo";

// Homepage — composes the 11-section Wayback Aug 2020 IA (ADR-004, frame 3:6).
export default function Home() {
  return (
    <>
      <Seo
        path="/"
        description="Physician-formulated CBD wellness by Dr. Elaine Burns. Condition-specific formulas, tested to a 99.5% accuracy rating. Rooted in science, not folklore."
      >
        <script type="application/ld+json">
          {JSON.stringify(organizationJsonLd())}
        </script>
      </Seo>

      {/* 2 — Trust Strip */}
      <TrustStrip />
      {/* 3 — Hero */}
      <HomeHero />
      {/* 4 — Press Coverage, moved up from position 10 (Dr. Burns, 2026-09-01:
          "I did not even notice this down at the bottom"). Renders only when active
          articles exist. */}
      <PressCoverage />
      {/* 5 — Shop by Condition */}
      <ShopByCondition />
      {/* 6 — Quiz CTA */}
      <QuizCta />
      {/* 7 — Bestsellers */}
      <Bestsellers />
      {/* 8 — Meet Dr. Burns */}
      <MeetDrBurns />
      {/* 9 — Differentiators */}
      <Differentiators />
      {/* 10 — Testimonials */}
      <Testimonials />
      {/* 11 — Trust Verification */}
      <TrustVerification />
      {/* 12 — Subscribe & Save */}
      <SubscribeSave />
    </>
  );
}
